import { RoutePath } from 'enums/routePath';

const ROOT = `/`;

const BENCHMARKING_MSP_BENCHMARKS = `${ROOT}`;

const paths = {
  [RoutePath.BENCHMARKING_MSP_BENCHMARKS]: BENCHMARKING_MSP_BENCHMARKS,
};

export const pathArray = Object.values(paths);

export default paths;
